import { QueryClient } from '@tanstack/react-query';

/**
 * Module-scoped singleton — never create QueryClient inside a component render.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
